import React, { Component, createRef } from 'react';
import { ScrollView, View, TouchableWithoutFeedback, Platform, Dimensions } from 'react-native';

import {
  VFScreen,
  ErrorScreen,
  VFBanner,
  VFText,
  Card,
  FilterBar
} from '@vfgroup-oneplatform/foundation/Components';
import { ShimmerWrapper } from '@vfgroup-oneplatform/foundation/Components/Shimmer';
import {
  Colors,
  LightThemeColors,
  withTheme,
} from '@vfgroup-oneplatform/foundation/Components/Themes';
import { TypesList } from '@vfgroup-oneplatform/foundation/Components/Themes/Types';
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';
import {
  isArray as _isArray,
  slice as _slice,
  isUndefined as _isUndefined,
  isEqual as _isEqual,
  isEmpty as _isEmpty,
  isFunction as _isFunction,
  get as _get,
  isNull as _isNull,
  isString as _isString,
} from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

import { billCardLoadingConfig } from '../../Common/LoadingConfigurations/BillCardLoading/BillCardLoading.config';
import { currentBillPaymentDueDateLoading } from '../../Common/LoadingConfigurations/CurrentBillPaymentDueDateLoading/CurrentBillPaymentDueDateLoading';
import {
  Chart,
  VfView,
  HeadLine,
  BillCard,
  CurrentBillCard,
  NoBills,
  NegativeBillQuickAction,
  AutoPaymentCard,
} from '../../Components';
import { Images } from '../../Themes';
import { DateFormatters, BillingTrackingManager } from '../../Utils';
import BillingTestKeys from '../../Utils/BillingTestKeys.js';

import { Bill_Status } from '../../Utils/BillStatus.Enum'

import styles from './Billing.Styles';

function getDisplayedBills(billsData, pageNumber, pageSize, currentBills) {
  const endIndex = pageNumber === 1 && currentBills?.length > 0 ? pageNumber * pageSize - 1 : pageNumber * pageSize;
  return _slice(billsData, 0, endIndex);
}

class Billing extends Component {
  static getDerivedStateFromProps(props, state) {
    const {
      billsCards = {},
      internalPagination,
      billsDisplayedPerPage,
      currentBillsCards,
      currentPage,
    } = props;

    const newState = {};

    //fake commit

    if (billsCards.isLoading !== state.isBillsLoading) {
      newState.isBillsLoading = billsCards.isLoading;

      // new data was being loaded and it is done loading
      if (state.isBillsLoading && !billsCards.isLoading) {
        if (internalPagination) {
          // double check if a reload occurs should it start from the beginning or keep the current page
          newState.displayedBills = getDisplayedBills(
            billsCards.data,
            state.currentPage,
            billsDisplayedPerPage,
            currentBillsCards?.data,
          );
        } else {
          newState.displayedBills = billsCards.data;
        }
      }
    } else if (
      _isUndefined(billsCards.isLoading) &&
      _isUndefined(state.isBillsLoading) &&
      _isArray(billsCards.data)
    ) {
      // Handle bills update if the user is passing data directly without adding loading
      // need to check if the an update is needed
      if (internalPagination) {
        const currentData = getDisplayedBills(
          billsCards.data,
          state.currentPage,
          billsDisplayedPerPage,
          currentBillsCards?.data,
        );

        if (!_isEqual(currentData, state.displayedBills)) {
          newState.displayedBills = currentData;
        }
      } else if (!_isEqual(billsCards.data, state.displayedBills)) {
        newState.displayedBills = billsCards.data;
      }
    } else if (
      !internalPagination &&
      billsCards.data &&
      !_isEqual(billsCards.data, state.displayedBills)
    ) {
      // if internalPagination is set to false and there is an update in the props it should reflect to the state directly
      newState.displayedBills = billsCards.data;
    }

    const newDisplayedBills = getDisplayedBills(
      billsCards.data,
      currentPage ? currentPage : state.currentPage,
      billsDisplayedPerPage,
      currentBillsCards?.data,
    );
    if (!_isEqual(newDisplayedBills, state.displayedBills)) {
      newState.displayedBills = newDisplayedBills;
    }

    if (!_isEmpty(newState)) {
      return newState;
    }

    return null;
  }

  constructor(props) {
    super(props);

    const { billsCards = {}, internalPagination, billsDisplayedPerPage, currentBillsCards, billTypes } = props;

    let initialDisplayedBills = [];
    const initialPageNumber = 1;

    if (!billsCards.isLoading && _isArray(billsCards.data)) {
      if (internalPagination) {
        initialDisplayedBills = getDisplayedBills(
          billsCards.data,
          initialPageNumber,
          billsDisplayedPerPage,
          currentBillsCards?.data,
        );
      } else {
        initialDisplayedBills = billsCards.data;
      }
    }

    this.state = {
      displayedBills: initialDisplayedBills,
      currentPage: initialPageNumber,
      isBillsLoading: billsCards.isLoading,
      isNegativeBillModalVisible: false,
      isBorderVisible: false,
      isInitialTrackingDataSent: false,
      filterByType: '',
      chartRef: createRef(null)
    };
    //offset at which current bill card is hidden
    this.currentBillsCardsEndOffset = 540;
    this.fullAutoPaymentDate = [];
  }

  componentDidMount() {
    if (!this.state.isBillsLoading && !this.props.currentBillsCards?.isLoading) {
      this.sendTrackingInfo();
      this.setState({ isInitialTrackingDataSent: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { currentBillsCards: prevCurrentBillsCards } = prevProps;
    const { currentBillsCards } = this.props;
    const { isBillsLoading: prevIsBillsLoading } = prevState;
    const { isBillsLoading, isInitialTrackingDataSent } = this.state;

    if (
      (prevCurrentBillsCards?.isLoading || prevIsBillsLoading) &&
      !currentBillsCards?.isLoading &&
      !isBillsLoading &&
      !isInitialTrackingDataSent
    ) {
      this.sendTrackingInfo();
    }
  }

  onScrollHandling = ({ nativeEvent }) => {
    if (
      (this.state.isBorderVisible === true && nativeEvent.contentOffset.y < 50) ||
      (this.state.isBorderVisible === false && nativeEvent.contentOffset.y >= 50)
    ) {
      this.setState({
        isBorderVisible: !this.state.isBorderVisible,
      });
    }
    if (
      nativeEvent.contentOffset.y >= this.currentBillsCardsEndOffset &&
      !this.state.isPrevBillsTrackingDataSent
    ) {
      this.sendTrackingInfo(true);
      this.setState({ isPrevBillsTrackingDataSent: true });
    }
  };

  onShowMorePress = () => {
    const { billsCards = {}, internalPagination, billsDisplayedPerPage } = this.props;
    const { currentPage } = this.state;

    if (internalPagination) {
      const newPageNumber = currentPage + 1;
      const newDisplayedBills = getDisplayedBills(
        billsCards.data,
        newPageNumber,
        billsDisplayedPerPage,
        false,
      );

      this.setState({
        currentPage: newPageNumber,
        displayedBills: newDisplayedBills,
      });
    } else {
      if (_isFunction(billsCards.onShowMorePress)) {
        billsCards.onShowMorePress();
      }
    }
  };

  onCurrentBillPress = params => {
    const { currentBillsCards, withAutoBillStatus, withBillNegativeAmount } = this.props;
    this.trackOnBillCardPress(params);
    _isFunction(currentBillsCards.onPress) &&
      currentBillsCards.onPress({
        ...params,
        isCurrentBill: true,
        fullAutoPaymentDate: this.fullAutoPaymentDate,
        withAutoBillStatus,
        withBillNegativeAmount,
      });
  };

  onBarPress = bill => {
    const { getAdditionalTrackingInfo, chart } = this.props
    const { onBarPress } = chart

    const visitor_bill_amount_current_active = bill.value || 0;
    const visitor_bill_date_due_current_active = bill.endDate
      ? moment(bill.endDate).format('YYYYMMDD')
      : undefined;
    const additionalData = _isFunction(getAdditionalTrackingInfo) && getAdditionalTrackingInfo();

    const commonData = {
      event_action: 'See bill',
      event_category: 'Button',
      event_label: 'information',
      page_name: 'Billing',
      page_section: 'Billing:MyBills',
      visitor_bill_amount_current_active,
      visitor_bill_date_due_current_active,
    };
    BillingTrackingManager.trackEvent('ui_interaction', {
      ...commonData,
      ...additionalData,
    });

    onBarPress(bill)
  }

  getHintTextProps = () => {
    const {
      currentBillsCards = {},
      autoPaymentCardProps: { isAutoBillActivated, autoBillPayDate },
    } = this.props;

    const props = {
      i18nKey: '',
      placeHolders: '',
    };

    if (currentBillsCards && currentBillsCards?.data !== 0) {
      if (this.props.withAutoBillStatus && isAutoBillActivated) {
        this.fullAutoPaymentDate = [autoBillPayDate?.day, autoBillPayDate?.month];
        props.i18nKey = 'billing_current_bill_auto_pay';
        props.placeHolders = this.fullAutoPaymentDate;
        return props;
      }
      props.i18nKey = 'billing_credit_card_paid_date';
      props.placeHolders = currentBillsCards?.data?.[0]?.paymentInfo;
    }
    return props;
  };

  getNumberOfRemainingBills = () => {
    const { billsCards = { data: [] } } = this.props;

    let numberOfRemainingBills = 0;

    if (
      this.props.internalPagination &&
      this.state.displayedBills.length < _get(billsCards, 'data.length', 0)
    ) {
      const differenceInBillsNumbers = billsCards.data.length - this.state.displayedBills.length;

      numberOfRemainingBills =
        differenceInBillsNumbers > this.props.billsDisplayedPerPage
          ? this.props.billsDisplayedPerPage
          : differenceInBillsNumbers;
    } else if (!this.props.internalPagination) {
      numberOfRemainingBills = billsCards.monthsRemaining;
    }

    return numberOfRemainingBills;
  };

  trackBillingBannerOnPress = () => {
    const { currentBillsCard, billingBannerProps, getAdditionalTrackingInfo } = this.props;

    currentBillsCard?.data.forEach(currentBillCard => {
      const visitor_bill_amount_current_active = currentBillCard.value || 0;
      const visitor_bill_date_due_current_active = currentBillCard.endDate
        ? moment(currentBillCard.endDate).format('YYYYMMDD')
        : undefined;
      const additionalData = _isFunction(getAdditionalTrackingInfo) && getAdditionalTrackingInfo();

      const commonData = {
        event_action: 'OnClick',
        event_category: 'Button',
        page_name: 'My Bill',
        page_section: 'Billing:Auto Bill Payment Quick Action',
        event_label: ContentManager.translate(billingBannerProps.primaryButtonTitle),
        visitor_bill_amount_current_active,
        visitor_bill_date_due_current_active,
      };
      BillingTrackingManager.trackEvent('ui_interaction', {
        ...commonData,
        ...additionalData,
      });
    })

  };

  trackOnBillCardPress = (currentBillCard) => {
    const { getAdditionalTrackingInfo } = this.props;
    const visitor_bill_amount_current_active = currentBillCard.value || 0;
    const visitor_bill_date_due_current_active = currentBillCard.endDate
      ? moment(currentBillCard.endDate).format('YYYYMMDD')
      : undefined;
    const additionalData = _isFunction(getAdditionalTrackingInfo) && getAdditionalTrackingInfo();

    const commonData = {
      event_action: 'OnClick',
      event_category: 'Card',
      event_label: 'information',
      page_name: 'Billing',
      page_section: 'Billing:MyBills',
      visitor_bill_amount_current_active,
      visitor_bill_date_due_current_active,
    };
    BillingTrackingManager.trackEvent('ui_interaction', {
      ...commonData,
      ...additionalData,
    });
  };

  sendTrackingInfo = isPreviousBillsSection => {
    const { currentBillsCards, getAdditionalTrackingInfo } = this.props;
    if (currentBillsCards) {
      const {
        data
      } = currentBillsCards;

      const { displayedBills } = this.state

      if (displayedBills.length > 0) {
        data.forEach(currentBillCard => {
          const visitor_bill_amount_current_active = currentBillCard.value || 0;
          const visitor_bill_date_due_current_active = currentBillCard.endDate
            ? moment(currentBillCard.endDate).format('YYYYMMDD')
            : undefined;

          const commonData = {
            visitor_bill_amount_current_active,
            visitor_bill_date_due_current_active,
          }
          const screenData = {
            page_name: 'Billing',
            page_section: 'Billing:MyBills',
            journey_name: 'View all bills (2nd level page)'
          }
          let screenTitle = 'Billing page (2nd level)'

          const additionalData = _isFunction(getAdditionalTrackingInfo) && getAdditionalTrackingInfo();

          if (isPreviousBillsSection && this.state.displayedBills.length > 0) {
            screenTitle = '(Scroll) - Billing page (2nd level)'
          }

          BillingTrackingManager.trackView(screenTitle, {
            ...commonData,
            ...screenData,
            ...additionalData,
          })


        })
      } else {
        const screenData = {
          page_name: 'Current Bill',
          page_section: 'Billing:MyBills',
          journey_name: 'Zero bill/ First bill'
        }
        const screenTitle = 'Billing page (2nd level)'

        const additionalData = _isFunction(getAdditionalTrackingInfo) && getAdditionalTrackingInfo()

        BillingTrackingManager.trackView(screenTitle, {
          ...screenData,
          ...additionalData,
        })
      }
    }
  };

  isNoBillsStatus = () => {
    const { currentBillsCards = {}, billsCards = { data: [] }, renderHeader } = this.props;
    const { isBillsLoading } = this.state;
    const previousBillsError = _get(billsCards, 'isError', false);

    // eslint-disable-next-line prettier/prettier
    const { isLoading: _, onPress: __, getAdditionalTrackingInfo: ___, paymentInfo: ____, imageListProp: _____, ..._data } = currentBillsCards; // NOSONAR
    return (
      !isBillsLoading &&
      _get(billsCards, 'data.length', 0) === 0 &&
      !previousBillsError &&
      (!_isFunction(renderHeader)
        ? (_get(currentBillsCards, 'data.length', 0) === 0 && !currentBillsCards.isLoading && !currentBillsCards.isError)
        : _isNull(renderHeader()))
    );
  };

  toggleNegativeBillModal = () => {
    this.setState({
      isNegativeBillModalVisible: !this.state.isNegativeBillModalVisible,
    });
  };

  closeNegativeBillModal = () => {
    this.setState({
      isNegativeBillModalVisible: false,
    });
  };

  hasShowMoreButton = () => {
    const { internalPagination, billsCards = { data: [] } } = this.props;
    let shouldDisplayShowMoreButton = false;

    if (
      internalPagination &&
      this.state.displayedBills.length < _get(billsCards, 'data.length', 0)
    ) {
      shouldDisplayShowMoreButton = true;
    } else if (!internalPagination) {
      shouldDisplayShowMoreButton = billsCards.showMoreButton;
    }

    return shouldDisplayShowMoreButton;
  };

  renderPreviousBills = () => {
    const { billsCards = { data: [] } } = this.props;
    const previousBillsError = _get(billsCards, 'isError', false);
    const isErrorShowMore = _get(billsCards, 'isErrorShowMore', false);

    let filteredBillData = billsCards.data

    if (this.state.filterByType != '') {
      filteredBillData = this.state.displayedBills.filter(item => item.billType === this.state.filterByType)
    }

    return (
      <VfView style={styles.flatListContainerStyle(this.hasShowMoreButton())}>
        {this.renderLoading(this.state.isBillsLoading)}

        {billsCards &&
          !previousBillsError &&
          filteredBillData?.map((item, index) =>
            this.renderBillItem(item, index),
          )}
        {isErrorShowMore ? (
          this.renderErrorCard(billsCards)
        ) : (
          <View
            style={
              this.hasShowMoreButton() ? styles.flatListFooterStyle : styles.flatListLastItemStyle
            }
          />
        )}
      </VfView>
    );
  };
  renderErrorCard = billsCards => {
    return (
      <Card style={styles.cardStyle(this.props.theme)}>
        <ErrorScreen
          iconName="ic_warning_mid"
          text="billing_previous_bill_show_more_error_text"
          textButton="billing_previous_bill_show_more_error_try_again_button"
          backgroundStyle={styles.errorPreviousBillsShowMoreBackgroundStyle}
          iconStyle={styles.errorPreviousBillShowMoreIconStyle}
          textStyle={styles.errorPreviousBillsShowMoreText}
          onPress={_get(billsCards, 'onShowMoreTryAgainPress', undefined)}
        />
      </Card>
    );
  };

  renderLoading = isLoading => {
    const { theme } = this.props;

    return isLoading ? (
      <ShimmerWrapper
        isLoading={isLoading}
        loadingConfig={billCardLoadingConfig}
        containerStyle={styles.loadingContainerStyle(theme)}
      />
    ) : null;
  };

  renderBillItem = (item, index) => {
    const { billsCards, unPaidCardDescriptionText, unPaidCardDescriptionTextStyle } = this.props;

    const withTimePeriodDisplayed = _get(billsCards, 'withTimePeriodDisplayed', false);
    const withServicesExtraLabel = _get(billsCards, 'withServicesExtraLabel', false);
    const servicesExtraLabel = _get(billsCards, 'servicesExtraLabel', '');

    const isAvailableBill = !_isNull(item.value);
    return (
      isAvailableBill && (
        <VfView
          test
          style={styles.marginBetweenTitle}
          testID={`${BillingTestKeys.billingBillItem}`}
          key={index}
        >
          <BillCard
            isLoading={this.state.isBillsLoading}
            unPaidCardDescriptionText={unPaidCardDescriptionText}
            unPaidCardDescriptionTextStyle={unPaidCardDescriptionTextStyle}
            unPaidCardDescriptionTextPlaceholders={!_isNull(item?.paymentInfo) && item?.paymentInfo}
            onPress={(additionalInfo = {}) => {
              billsCards.onBillPress({ ...item, ...additionalInfo });
              this.trackOnBillCardPress(item);
            }}
            isCurrencyFirst={this.props.isCurrencyFirst}
            isStartDateBillDate={this.props.isStartDateBillDate}
            withTimePeriodDisplayed={withTimePeriodDisplayed}
            getTimePeriod={this.props.getTimePeriod}
            getYear={this.props.getYear}
            getMonth={this.props.getMonth}
            getShortMonth={this.props.getShortMonth}
            getMonthNumber={this.props.getMonthNumber}
            monthTestID={`${BillingTestKeys.billingBillMonthText}`}
            amountTestID={`${BillingTestKeys.billingBillAmountText}`}
            {...item}
            withServicesExtraLabel={withServicesExtraLabel}
            servicesExtraLabel={servicesExtraLabel}
            billCardTestID={`${BillingTestKeys.billingBillCard}`}
            renderFooter={this.props.renderBillCardFooter}
            withBillNegativeAmount={this.props.withBillNegativeAmount}
            billAmountStyle={billsCards.billAmountStyle}
            toggleModal={this.toggleNegativeBillModal}
            billingNegativeValueNote={billsCards.negativeBillProps?.billingNegativeValueNote}
            billingNegativeValueNoteStyle={
              billsCards.negativeBillProps?.billingNegativeValueNoteStyle
            }
          />
        </VfView>
      )
    );
  };

  renderExtraBanners = () =>
    _isArray(this.props.extraBannersProps)
      ? this.props.extraBannersProps.map(bannerProps => <VFBanner {...bannerProps} />)
      : null;

  renderHeadLine = () => {
    const { billsCards = { data: [] }, headline, theme } = this.props;
    const previousBillsError = _get(billsCards, 'isError', false);
    return (
      headline && (
        <>
          <VfView
            style={
              this.hasShowMoreButton() && !previousBillsError
                ? styles.marginBetweenComponents
                : styles.marginForHeadline
            }
          >
            <VFText
              style={styles.manageSpeedHeadLine(theme)}
              i18nKey={'billing_manage_your_spending'}
            />
          </VfView>

          <VfView style={[styles.marginBetweenTitle, styles.lastComponent]}>
            <HeadLine
              title={'billing_spend_manager'}
              subtitle={'billing_cap_your_monthly_costs'}
              {...headline}
            />
          </VfView>
        </>
      )
    );
  };

  renderBills = () => {
    const {
      currentBillsCards = {},
      billsCards = { data: [] },
      headline,
      theme,
      billingBannerProps,
      withBillDate,
      getCustomHintTextProps,
      negativeBillQuickActionsProps = {},
    } = this.props;

    const _billingBannerProps = {
      ...billingBannerProps,
      onPrimaryButtonPress: () => {
        this.trackBillingBannerOnPress();
        _isFunction(billingBannerProps.onPrimaryButtonPress) &&
          billingBannerProps.onPrimaryButtonPress();
      },
    };

    const previousBillsError = _get(billsCards, 'isError', false);
    const isErrorShowMore = _get(billsCards, 'isErrorShowMore', false);

    return (
      <ScrollView
        testID={BillingTestKeys.billingScreenScrollView}
        bounces={false}
        scrollEnabled={currentBillsCards && !currentBillsCards.isLoading}
        style={styles.container(theme)}
        contentContainerStyle={[this.props.withTray && styles.scrollViewContentContainerStyle,]}
        onScroll={this.onScrollHandling}
        scrollEventThrottle={20}
        nestedScrollEnabled={true}
        showsVerticalScrollIndicator={false}
        overScrollMode="always"
      >
        <View onStartShouldSetResponder={() => true}>
          {this.props.chart ? (
            <Chart
              isStartDateBillDate={this.props.isStartDateBillDate}
              getTimePeriod={this.props.getTimePeriod}
              getYear={this.props.getYear}
              getMonth={this.props.getMonth}
              getShortMonth={this.props.getShortMonth}
              getMonthNumber={this.props.getMonthNumber}
              {...this.props.chart}
              onBarPress={this.onBarPress}
              billTypes={this.props.billTypes}
              ref={this.state.chartRef}
            />
          ) : null}

          {this.props.chart && this.props.billTypes && this.props?.billTypes?.data.length > 1 && <View style={styles.indicatorsContainer}>
            {this.props?.billTypes.data.map(item => {
              return (
                <View style={styles.indicatorItem}>
                  <View style={styles.indicatorPoint(item?.color)} />
                  <VFText
                    i18nKey={item?.name}
                    style={styles.indicatorText}
                  />
                </View>
              )
            })}
          </View>}

          {_isFunction(this.props.renderHeader) && this.props.renderHeader()}

          <VfView justify="center" alignItems="center" style={[Platform.OS === 'web' && Dimensions.get('window').width > 700 && { paddingHorizontal: '10%' }]}>
            <VfView xs={Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 12 : 11}>
              {this.renderExtraBanners()}
              {!_isEmpty(currentBillsCards) && (
                <>
                  <VfView style={styles.marginBetweenComponents}>
                    <VfView row justify="space-between" alignItems="flex-end">
                      <VFText
                        style={styles.currentBillTitle(theme)}
                        i18nKey={currentBillsCards?.data?.length === 1 ? 'billing_current_bill_title' : 'billing_current_bills_title'}
                        testKey={BillingTestKeys.billingCurrentBillTitleText}
                      />
                      {currentBillsCards.isLoading ? (
                        <ShimmerWrapper
                          isLoading={currentBillsCards.isLoading}
                          loadingConfig={currentBillPaymentDueDateLoading}
                          containerStyle={styles.currentBillPaymentDueDate}
                        />
                      ) : (
                        <>
                          {currentBillsCards?.data?.length === 1 && currentBillsCards?.data?.[0]?.status !== Bill_Status.SETTLED && <VFText
                            style={styles.paidDate(theme)}
                            {...(_isFunction(getCustomHintTextProps)
                              ? getCustomHintTextProps()
                              : this.getHintTextProps())}
                            testKey={BillingTestKeys.billingCurrentBillToBePaidText}
                          />}
                        </>
                      )}
                    </VfView>
                  </VfView>
                  <VfView style={styles.marginBetweenTitle}>
                    <NegativeBillQuickAction
                      isVisible={
                        negativeBillQuickActionsProps.isVisible ??
                        this.state.isNegativeBillModalVisible
                      }
                      toggleModal={this.toggleNegativeBillModal}
                      closeModal={this.closeNegativeBillModal}
                      icon={negativeBillQuickActionsProps.icon || Images.icInfoCircleGrey}
                      QAtitle={
                        negativeBillQuickActionsProps.QAtitle ||
                        'billing_negative_bill_quick_action_title'
                      }
                      title={
                        negativeBillQuickActionsProps.title ||
                        'billing_negative_bill_quick_action_question_text'
                      }
                      description={
                        negativeBillQuickActionsProps.description ||
                        'billing_negative_bill_quick_action_description'
                      }
                      buttonTitle={
                        negativeBillQuickActionsProps.buttonTitle ||
                        'billing_negative_bill_quick_action_button_text'
                      }
                      getAdditionalTrackingInfo={this.props.getAdditionalTrackingInfo}
                      {...negativeBillQuickActionsProps}
                    />
                    {currentBillsCards?.data.length !== 0 && currentBillsCards?.data.map(currentBillCard => {
                      return <CurrentBillCard
                        isLoading={currentBillsCards?.isLoading}
                        key={currentBillCard?.id}
                        extraChargesText={'billing_current_bill_extra_charges'}
                        isCurrencyFirst={this.props.isCurrencyFirst}
                        isStartDateBillDate={this.props.isStartDateBillDate}
                        getTimePeriod={this.props.getTimePeriod}
                        getYear={this.props.getYear}
                        getMonth={this.props.getMonth}
                        withBillDate={withBillDate}
                        toggleModal={this.toggleNegativeBillModal}
                        {...currentBillCard}
                        {...theme}
                        onPress={this.onCurrentBillPress}
                        withBillNegativeAmount={this.props.withBillNegativeAmount}
                        currentBillAmountStyle={currentBillCard.currentBillAmountStyle}
                        billingNegativeValueNote={
                          currentBillCard.negativeBillProps?.billingNegativeValueNote
                        }
                        withBadge={currentBillsCards?.data.length === 1 ? (
                          currentBillCard?.status === Bill_Status.SETTLED ? true : false
                        ) : this.props.currentBillsCards?.withBadge}
                      />
                    })}
                  </VfView>
                </>
              )}
              <>
                {this.props.withAutoPaymentBanner && (
                  <VFBanner
                    backgroundColors={[Colors.darkCyan, Colors.turquoise]}
                    {..._billingBannerProps}
                  />
                )}
              </>
              <>
                {this.props.withAutoPaymentCard && (
                  <AutoPaymentCard {...this.props.autoPaymentCardProps} />
                )}
              </>
              {(_get(billsCards, 'isLoading', true) ||
                previousBillsError ||
                _get(billsCards, 'data.length', 0) > 0) && (
                  <VfView style={styles.marginBetweenComponents}>
                    <VFText
                      style={styles.previousBillTitle(theme)}
                      i18nKey={'billing_previous_bill_title'}
                      testKey={BillingTestKeys.billingPreviousBillTitleText}
                    />
                    {_isString(this.props.previousBillSubTitle) && (
                      <VFText
                        style={styles.previousBillSubTitle(theme)}
                        i18nKey={this.props.previousBillSubTitle}
                        testKey={BillingTestKeys.previousBillSubTitle}
                      />
                    )}
                  </VfView>
                )}

              {previousBillsError && (
                <ErrorScreen
                  text="billing_previous_bill_error_text"
                  textButton="billing_previous_bill_error_try_again_button"
                  backgroundStyle={styles.errorPreviousBillsBackgroundStyle}
                  iconStyle={styles.errorPreviousBillsIconStyle}
                  onPress={_get(billsCards, 'onTryAgainPress', undefined)}
                />
              )}

              {this.props.billsCards?.filterData?.length > 1 && !previousBillsError
                && !billsCards.isLoading
                && (_get(billsCards, 'data.length', 0) > 0) && <FilterBar
                  filterData={this.props.billsCards?.filterData}
                  withSeeAll
                  setSelectedCategories={(cat) => {
                    if (cat) {
                      this.setState({ filterByType: cat })
                    } else {
                      this.setState({ filterByType: '' })
                    }
                  }}
                  selectedCategories={this.state.filterByType}
                  isLoading={false}
                  theme={theme}
                  containerStyle={{ marginTop: 20, paddingLeft: 0 }}
                />}

              {this.renderPreviousBills()}

              {/* {billsCards.withShowMoreLoader && (
                <VfView justify="center" alignItems="center">
                  <VFLottieView
                    type={LottieTypes.spinner}
                    autoPlay={true}
                    loop={true}
                    lottieViewStyle={styles.lottieViewStyle}
                  />
                </VfView>
              )}

              {!previousBillsError && this.hasShowMoreButton() && !isErrorShowMore && (
                <TouchableWithoutFeedback
                  onPress={this.onShowMorePress}
                  testID={BillingTestKeys.billingShowMoreBtn}
                >
                  <View>
                    <VFText
                      style={[styles.showMoreTextStyle(theme), !headline ? styles.lastComponent : {}]}
                      placeHolders={[this.getNumberOfRemainingBills()]}
                      i18nKey={'billing_show_more_title'}
                      testKey={BillingTestKeys.billingShowMoreBtnText}
                    />
                  </View>
                </TouchableWithoutFeedback>
              )} */}

              {this.renderHeadLine()}
            </VfView>
          </VfView>

        </View>
      </ScrollView >
    );
  };

  render() {
    const { billsCards = { data: [] }, theme, isError, errorScreenProps, headerStyle } = this.props;
    return (
      <TouchableWithoutFeedback
        onPress={() => this.state?.chartRef?.current?.closeBillDetails()}
        accessible={true}
      >
        <View style={styles.flex1}>
          <VFScreen
            testID={BillingTestKeys.billingVFScreenView}
            headerStyle={[
              styles.headerStyle(theme),
              headerStyle,
            ]}
            title={'billing_landing_title'}
            {...this.props.vfScreen}
            closeButtonTestID={BillingTestKeys.billingCloseBtn}
            titleTextAccessibilityLabel={BillingTestKeys.billingScreenTitleText}

          >
            {isError ? (
              <ErrorScreen
                text="billing_error_text"
                textButton="billing_error_try_again_button"
                backgroundStyle={styles.errorPreviousBillsBackgroundStyle}
                iconStyle={styles.errorAllBillsIconStyle}
                onPress={_get(this.props, 'onTryAgainPress', undefined)}
                textStyle={styles.errorAllBillsTextStyle(theme)}
                testID={BillingTestKeys.billsError}
                {...errorScreenProps}
              />
            ) : this.isNoBillsStatus() ? (
              <ScrollView
                testID={BillingTestKeys.billingScreenNoBillsScrollView}
                bounces={false}
                style={styles.container(theme)}
              >
                <View onStartShouldSetResponder={() => true}>
                  <VfView justify="center" alignItems="center">
                    <VfView xs={11}>{this.renderExtraBanners()}</VfView>
                    <NoBills
                      title={'billing_no_bill_title'}
                      subtitle={'billing_no_bill_subtitle'}
                      subtitlePLaceholder={[this.props.nextBillDate]}
                    />
                  </VfView>
                </View>
              </ScrollView>
            ) : (
              this.renderBills()
            )}
          </VFScreen>
        </View>
      </TouchableWithoutFeedback>
    );
  }
}

Billing.defaultProps = {
  internalPagination: true,
  billsDisplayedPerPage: 12,
  isStartDateBillDate: false,
  getTimePeriod: DateFormatters.getTimePeriod,
  getYear: DateFormatters.getYear,
  getMonth: DateFormatters.getMonth,
  getShortMonth: DateFormatters.getShortMonth,
  getMonthNumber: DateFormatters.getMonthNumber,
  withTray: false,
  theme: LightThemeColors,
  autoPaymentCardProps: {},
  currentBillsCards: {},
  billsCards: {
    withShowMoreLoader: false,
  },
  withBillNegativeAmount: true,
  isError: false,
};

Billing.propTypes = {
  isErrorShowMore: PropTypes.bool,
  isError: PropTypes.bool,
  extraBannersProps: PropTypes.arrayOf(PropTypes.object),
  vfScreen: PropTypes.object,
  errorScreenProps: PropTypes.object,
  getCustomHintTextProps: PropTypes.func,
  headline: PropTypes.object,
  billsCards: PropTypes.object,
  currentPage: PropTypes.number,
  currentBillsCards: PropTypes.object,
  unPaidCardDescriptionText: PropTypes.string,
  unPaidCardDescriptionTextStyle: PropTypes.object,
  chart: PropTypes.object,
  title: PropTypes.string,
  background: PropTypes.any,
  internalPagination: PropTypes.bool,
  billsDisplayedPerPage: PropTypes.number,
  noBillImage: PropTypes.string,
  nextBillDate: PropTypes.string,
  isCurrencyFirst: PropTypes.bool,
  isStartDateBillDate: PropTypes.bool,
  getTimePeriod: PropTypes.func,
  getYear: PropTypes.func,
  getMonth: PropTypes.func,
  getShortMonth: PropTypes.func,
  getMonthNumber: PropTypes.func,
  withTray: PropTypes.bool,
  theme: PropTypes.object,
  withAutoPaymentBanner: PropTypes.bool,
  withBillDate: PropTypes.bool,
  billingBannerProps: PropTypes.shape({
    backgroundColors: PropTypes.array,
    title: PropTypes.string,
    description: PropTypes.string,
    primaryButtonTitle: PropTypes.string,
    secondaryButtonTitle: PropTypes.string,
    onPrimaryButtonPress: PropTypes.func,
    onSecondaryButtonPress: PropTypes.func,
    withSecondaryButton: PropTypes.bool,
  }),
  withAutoPaymentCard: PropTypes.bool,
  previousBillSubTitle: PropTypes.string,
  autoPaymentCardProps: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    primaryButtonTitle: PropTypes.string,
    isAutoBillActivated: PropTypes.bool,
    onToggleActiveStatus: PropTypes.func,
    autoBillPayDate: PropTypes.shape({
      day: PropTypes.string,
      month: PropTypes.string,
    }),
  }),
  renderHeader: PropTypes.func,
  getAdditionalTrackingInfo: PropTypes.func,
  withAutoBillStatus: PropTypes.bool,
  renderBillCardFooter: PropTypes.func,
  withBillNegativeAmount: PropTypes.bool,
  negativeBillQuickActionsProps: PropTypes.shape({
    isVisible: PropTypes.bool,
    icon: PropTypes.string,
    QAtitle: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    buttonTitle: PropTypes.string,
    withCloseButton: PropTypes.bool,
    buttonStyle: PropTypes.object,
    QAtitleStyle: PropTypes.object,
    titleStyle: PropTypes.object,
    descriptionStyle: PropTypes.object,
    descriptionContainerStyle: PropTypes.object,
    buttonType: PropTypes.oneOf(TypesList),
  }),
  headerStyle: PropTypes.object,
  billTypes: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.any,
      color: PropTypes.string
    }))
  })
};

export default withTheme(Billing);
export { getDisplayedBills };
